"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SelectExtended;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@sart/styles");
var _Text = _interopRequireDefault(require("./Text"));
var _Label = _interopRequireDefault(require("./Label"));
var _Space = _interopRequireDefault(require("./Space"));
var _Select = _interopRequireDefault(require("./Select"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _excluded = ["label", "footer", "error", "hideError", "showErrorAndFooter", "styles", "labelStyle", "containerSyle", "footerStyle", "footerErrorStyle", "footerErrorContainerStyle", "errorStyle"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function SelectExtended(props) {
  var label = props.label,
    footer = props.footer,
    error = props.error,
    hideError = props.hideError,
    showErrorAndFooter = props.showErrorAndFooter,
    _selectStyles = props.styles,
    labelStyle = props.labelStyle,
    containerSyle = props.containerSyle,
    footerStyle = props.footerStyle,
    footerErrorStyle = props.footerErrorStyle,
    footerErrorContainerStyle = props.footerErrorContainerStyle,
    errorStyle = props.errorStyle,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  // React Select
  // https://react-select.com/props#select-props
  // Select Props > Style modifier methods

  var selectStyles = _objectSpread(_objectSpread({}, _selectStyles), {}, {
    control: function control(provided) {
      return _objectSpread(_objectSpread(_objectSpread({}, provided), _selectStyles && _selectStyles.control ? _selectStyles.control(provided) : {}), error ? {
        borderColor: _styles.colors.error
      } : {});
    },
    placeholder: function placeholder(provided) {
      return _objectSpread(_objectSpread(_objectSpread({}, provided), _selectStyles && _selectStyles.placeholder ? _selectStyles.placeholder(provided) : {}), error ? {
        color: _styles.colors.error
      } : {});
    }
  });
  var footerStyles = [styles.footer, footerStyle];
  var footerErrorStyles = [styles.footerError, footerErrorStyle];
  var footerErrorContainerStyles = [styles.footerErrorContainer, footerErrorContainerStyle];
  var showError = error && !hideError;
  var showFooter = showErrorAndFooter ? footer : footer && !error;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: [styles.container, containerSyle]
  }, label && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    style: labelStyle
  }, label), /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  })), /*#__PURE__*/_react["default"].createElement(_Select["default"], _objectSpread({
    styles: selectStyles
  }, rest)), (showError || showFooter) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Space["default"], {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: footerErrorContainerStyles
  }, showError && /*#__PURE__*/_react["default"].createElement(_ErrorMessage["default"], {
    style: footerErrorStyles
  }, error, showFooter ? '. ' : ''), showFooter && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    style: footerStyles
  }, footer))));
}
SelectExtended.propTypes = _objectSpread(_objectSpread({}, _Select["default"].propTypes), {}, {
  label: _propTypes["default"].string
});
var styles = _reactNative.StyleSheet.create({
  container: {
    flex: 1
  }
});